var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"margin":"0"}},[_c('span',[_vm._v(_vm._s(_vm.item.type)+": ")]),(_vm.location)?_c('span',[_vm._v(" "+_vm._s(_vm.location))]):_vm._e(),(_vm.item.subject)?_c('span',[_c('br'),_vm._v(_vm._s(_vm.item.subject))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }